import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["list"];

  connect() {
    this.boundKeydown = this.handleKeydown.bind(this);
    document.addEventListener("keydown", this.boundKeydown);
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown);
  }

  handleKeydown(event) {
    if (event.key !== "n" && event.key !== "N") return;
    if (this.shouldIgnore(event)) return;

    event.preventDefault();
    this.go(event);
  }

  go(event) {
    if (event && event.preventDefault) event.preventDefault();
    const next = this.findNextPendingLink();
    if (next) next.click();
  }

  findNextPendingLink() {
    if (!this.hasListTarget) return null;
    const cards = this.listTarget.querySelectorAll("[data-job-questions--next-unanswered-status='pending']");
    if (!cards.length) return null;

    const selected = this.listTarget.querySelector(".jq-v2-question-card.is-selected");
    let foundCurrent = !selected;

    for (const card of cards) {
      if (!foundCurrent) {
        if (card === selected) foundCurrent = true;
        continue;
      }
      const link = card.querySelector("a.jq-v2-card-link");
      if (link) return link;
    }

    const firstLink = cards[0].querySelector("a.jq-v2-card-link");
    return firstLink || null;
  }

  shouldIgnore(event) {
    const tag = (event.target.tagName || "").toLowerCase();
    if (tag === "input" || tag === "textarea" || tag === "select") return true;
    if (event.target.isContentEditable) return true;
    if (event.metaKey || event.ctrlKey || event.altKey) return true;
    return false;
  }
}
